var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.48 213.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(0.38 1.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.59,1.3a56.46,56.46,0,0,1,.5,12.46,2.71,2.71,0,0,1-3,2.36,2.6,2.6,0,0,1-.86-.26C105.09,10.16,63.7-1.59,35.16,30.23c-2.18,2.24.55,2.07.55,2.07H45.83A2.15,2.15,0,0,1,48,34.39a3.38,3.38,0,0,1,0,.45C46.36,42.5,38.57,66,1.13,85A2,2,0,0,0,.2,87.67l0,0a1.69,1.69,0,0,0,.23.36c6.82,7.85,15.93,11,22.81,12.27a31.46,31.46,0,0,0,16.47-1.65l2.88-1.07a5.85,5.85,0,0,0,3.56-4A52.16,52.16,0,0,1,82.51,57.54,15.65,15.65,0,0,1,80.1,49.1c0-11.88,12.74-20.76,25.33-13.73a12.55,12.55,0,0,1,5.08,5.35c3,6.11,2.54,12.25-.36,16.82a50.16,50.16,0,0,1,15.11,6.92,3.85,3.85,0,0,0,4.14.87s19.49-10.07,19.08-32.45C148.1,14.1,128.5,3.15,122.19.11A1.17,1.17,0,0,0,121.7,0a1.14,1.14,0,0,0-1.13,1.15h0V1.3",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -284.7,
    cy: -5.61,
    r: 0.62,
    gradientTransform: "matrix(103, 0, 0, -102.97, 29375.61, -200.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1bb91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2a37b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    transform: "translate(0.38 1.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,91.62a1,1,0,0,0,.5,1.32.47.47,0,0,0,.15.06,1,1,0,0,0,.69,0l30.2-9.77a25.28,25.28,0,0,1,15.58,0L134.33,93a1,1,0,0,0,1.32-.5,1,1,0,0,0,0-.87,42.51,42.51,0,0,0-78.59,0",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -277.18,
    cy: -22.06,
    r: 1.06,
    gradientTransform: "matrix(27.9, 0, 0, -27.93, 7766.97, -268.6)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    transform: "translate(0.38 1.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.27,49.1A9.07,9.07,0,1,0,96.34,40a9.07,9.07,0,0,0-9.07,9.1h0",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -271.62,
    cy: -34.24,
    r: 0.5,
    gradientTransform: "matrix(18.14, 0, 0, -18.14, 5023.66, -241.2)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    transform: "translate(0.38 1.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.26,169.61v0m-1.86,0v0M79.63,191.4l-2.75-1.05a10.85,10.85,0,0,1-3.06-1.84c-.66-.62-.66-3.55-.43-4.63l3.4-16a1.79,1.79,0,0,1,2.09-1.42l.23.06,4.44,1.4a2.39,2.39,0,0,1,1.57,2.58l-3.29,19.6a1.56,1.56,0,0,1-1.55,1.38,1.82,1.82,0,0,1-.65-.12m31.14-1.26-3.22-19.6a2.37,2.37,0,0,1,1.58-2.58l4.43-1.4a1.79,1.79,0,0,1,2.26,1.12,1.05,1.05,0,0,1,.06.24l3.4,16c.23,1.08.23,4-.43,4.63a10.82,10.82,0,0,1-3.06,1.83L113,191.4a1.73,1.73,0,0,1-.64.12,1.56,1.56,0,0,1-1.55-1.39m-46.73-6.77-3.65-1.74a11.29,11.29,0,0,1-3-2.13c-.64-.7-.3-3.67.06-4.7l3.82-10.89a2.35,2.35,0,0,1,2.62-1.48l4.75,1a1.94,1.94,0,0,1,1.52,2.28v.07l-3.88,16.54a1.54,1.54,0,0,1-1.5,1.27,1.7,1.7,0,0,1-.76-.18m62.3-1.09-3.88-16.54a1.94,1.94,0,0,1,1.43-2.33H124l4.75-1a2.35,2.35,0,0,1,2.62,1.48l3.82,10.89c.37,1,.72,4,.1,4.7a10.55,10.55,0,0,1-2.93,2.12l-3.71,1.75a1.7,1.7,0,0,1-.76.18,1.54,1.54,0,0,1-1.51-1.27M93.29,149.21,65.55,139a14.4,14.4,0,0,1-2.79-1.36,10.32,10.32,0,0,1-1.6-3.75l-.6-2.93a7.82,7.82,0,0,1,.32-3.81l1.63-1.44a7.88,7.88,0,0,1,3.83.13l27,9.09a23.86,23.86,0,0,0,2.63.74,14.75,14.75,0,0,0,3.27-.74l27.08-9.09a7.72,7.72,0,0,1,3.82-.1l1.64,1.41a8,8,0,0,1,.33,3.82l-.61,3a14,14,0,0,1-.93,2.95c-.29.54-2.42,1.71-3.46,2.1L99.37,149.21a24.64,24.64,0,0,1-2.65.83h-.1a15.23,15.23,0,0,1-3.32-.83m11.81-53.05c-1.15.43-2.6,2.8-2.93,3.84l-2.11,6.63a5.94,5.94,0,0,1-2.33,2.9,3.77,3.77,0,0,1-1.42.54,3.68,3.68,0,0,1-1.4-.54,6,6,0,0,1-2.33-2.9L90.49,100c-.33-1-1-2.7-1.77-3.24-1.1-.74-3.79-.6-4.84-.3L50.93,105.8a10.74,10.74,0,0,0-3.33,1.71c-.77.64-.68,3.79-.4,4.85l7.93,29.76a26.24,26.24,0,0,1,.58,2.63,16.38,16.38,0,0,1-.9,3.22l-11.66,31.9a11.82,11.82,0,0,0-.69,3.43c0,.85,2.1,2.88,3,3.47l38.21,24.42a8.38,8.38,0,0,0,3.68,1.1,2,2,0,0,0,1.09-.17,1.78,1.78,0,0,0,.75-.69,8.38,8.38,0,0,0,1.48-3.55l4.45-36.27c.13-1.09.24-2,.24-2.09a1.52,1.52,0,0,1,0-.4v.35a.92.92,0,0,1,1-.78h0a.92.92,0,0,1,.78.8v-.15l.27,2.27,4.39,36.27a8.08,8.08,0,0,0,1.5,3.54,2.51,2.51,0,0,0,.75.7,1.87,1.87,0,0,0,1.07.17,8.38,8.38,0,0,0,3.68-1.1l38.35-24.42a11.36,11.36,0,0,0,2.6-2.34,2.45,2.45,0,0,0,.24-1.22v-.16a11.79,11.79,0,0,0-.5-3.18L137.87,148a25.11,25.11,0,0,1-.83-2.54,15.52,15.52,0,0,1,.58-3.31l7.86-29.75a11.14,11.14,0,0,0,.23-3.73c-.16-1-2.91-2.53-4-2.83L108.76,96.5a10.5,10.5,0,0,0-2.66-.5,3.06,3.06,0,0,0-1,.14",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: -285.02,
    cy: -4.92,
    r: 0.48,
    gradientTransform: "matrix(116.36, 0, 0, -116.36, 33269.48, -302.41)",
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.27,
    height: 102.97,
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.09,
    y: 66.92,
    width: 79.25,
    height: 27.93,
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.65,
    y: 41.62,
    width: 18.14,
    height: 18.14,
    fill: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.84,
    y: 97.61,
    width: 107.64,
    height: 116.36,
    fill: "url(#h)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingTiny);
export default __webpack_public_path__ + "static/media/loading-tiny.9752d5515dfd4830a91136cca33a21a1.svg";
export { ForwardRef as ReactComponent };